(ns common.widgets.preview-pop-up
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/material/styles" :as styles]
            ["react" :as react]
            [reagent.core :as r]))

(defn- preview-image [src]
  (let [theme (styles/useTheme)
        [anchor-el set-anchor-el] (react/useState nil)]
    [:<>
     [:> Icon {:color "primary"
               :font-size "small"
               :on-mouse-enter #(set-anchor-el (.-target %))
               :on-mouse-leave #(set-anchor-el nil)}
      "filter"]
     [:> Popper {:open (some? anchor-el)
                 :anchor-el anchor-el
                 :placement "top-start"
                 :sx {:max-width "25rem"}}
      [:img {:alt "Image is missing"
             :src src
             :style {:width "100%"
                     :border "1px solid"
                     :border-color (.. theme -palette -primary -main)}}]]]))

(defn- preview-text
  ([text]
   (preview-text text [:> Typography {:no-wrap true}
                       text]))
  ([text element]
   [:> Tooltip {:title (r/as-element text)
                :placement "bottom"
                :PopperProps {:onClick #(.stopPropagation %)}}
    element]))

(defmulti preview-pop-up (fn [type _]
                           type))

(defmethod preview-pop-up :default
  [_ text]
  [:div text])

(defmethod preview-pop-up :text
  [_ text]
  [preview-text text])

(defmethod preview-pop-up :image
  [_ src]
  [:f> preview-image src])

(defmethod preview-pop-up :image-url
  [_ src]
  [:> Stack
   {:direction "row"
    :align-items "center"
    :gap 2
    :sx #js {:overflow "hidden"}}
   [:f> preview-image src]
   [preview-text src [:> Link {:href src
                               :target "_blank"
                               :color "inherit"
                               :no-wrap true
                               :on-click #(.stopPropagation %)}
                      src]]])
